import React, { useEffect, useState } from 'react';
import { Container, Card, Tabs, Tab, Alert } from 'react-bootstrap';
import ConfigService from "../../services/config/ConfigService";
import LoadingSpinner from '../common/LoadingSpinner';
import './ConfigEdit.css';

const Tutorials = () => {
    /* Tutorials are: title, description, url, youtubeId*/
    const [tutorials, setTutorials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('0');

    useEffect(() => {
        const fetchTutorials = async () => {
            try {
                setError(null);
                const data = await ConfigService.getTutorials();
                console.log('Fetched tutorials:', data);
                setTutorials(data);
            } catch (err) {
                setError('Failed to load tutorials: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTutorials();
    }, []);

    
    const renderBody = () => {
        if (error) {
            return <Alert variant="danger">{error}</Alert>;
        }
        
        if (tutorials.length === 0) {
            return <Alert variant="info">No tutorials available.</Alert>;
        }

        return (
            <Tabs
                id="tutorials-tabs"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
            >
                {tutorials.map((tutorial, index) => {
                    const videoId = tutorial.youtubeId;
                    return (
                        <Tab key={index} eventKey={String(index)} title={tutorial.title}>
                            <div className="mt-4">
                                {tutorial.description && (
                                    <p className="text-muted mb-3">{tutorial.description}</p>
                                )}
                                {videoId && activeTab === String(index) ? (
                                    <div key={`video-${index}`} className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                                        <iframe
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                border: 'none',
                                            }}
                                            src={`https://www.youtube.com/embed/${videoId}`}
                                            title={tutorial.title}
                                            allowFullScreen
                                        />
                                    </div>
                                ) : (
                                    <Alert variant="warning">
                                        Unable to load video. <a href={tutorial.url} target="_blank" rel="noopener noreferrer">Watch on YouTube</a>
                                    </Alert>
                                )}
                            </div>
                        </Tab>
                    );
                })}
            </Tabs>
        );
    }
   
    return (
        <Container className="my-4">
            {/* MODERNIZED: Page is wrapped in a main Card for a modern look */}
            <Card className="h-100 shadow-sm">
                <Card.Header className="d-flex flex-column gap-2">
                    <div className="d-flex align-items-center gap-2">
                        <h2 className="mb-0">Tutorials</h2>
                    </div>
                </Card.Header>
                <Card.Body className="p-4">
                    
                    {loading ? <div className='loadingSpinner'><LoadingSpinner /></div> : renderBody()}
                </Card.Body>
            </Card>
        </Container>
    );

};

export default Tutorials;
